import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FeedbackData, FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

import { I18nService } from '../../../../../../i18n/services';
import { UsersService } from '../../../../../../services/users';
import { ISendVerificationEmailDialogData } from './users-send-verification-email.models';

@Component({
	selector: 'app-users-send-verification-email',
	templateUrl: './users-send-verification-email.dialog.html'
})
export class UsersSendVerificationEmailDialogComponent extends OnDestroyMixin {
	constructor(
		private feedbackService: FeedbackService,
		private usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		@Inject(MAT_DIALOG_DATA) public dialogData: ISendVerificationEmailDialogData,
		private dialogRef: MatDialogRef<UsersSendVerificationEmailDialogComponent>,
		private i18nService: I18nService
	) {
		super();
	}

	public onFormSubmit(): void {
		const data: FeedbackData = {
			title: FeedbackTitle.warning,
			message: this.i18nService.get('Are you sure you want to continue?', 'app.prompt.users.send-verification-email.confirm-message'),
			style: FeedbackStyle.error,
			callback: (confirmed: boolean) => {
				if (confirmed) {
					this.sendVerificationEmail();
				} else {
					this.dialogRef.close();
				}
			}
		};

		this.feedbackService.confirm(data);
	}

	private sendVerificationEmail(): void {
		this.progressIndicatorService.spinner(true);

		this.usersService
			.sendVerificationEmail(this.dialogData.user.email)
			.subscribe(
				() => {
					this.feedbackService.notification({
						msg: this.i18nService.get(
							'Successfully requested verification email.',
							'app.descriptor.users.verification-email-sent'
						),
						config: { duration: 4000 }
					});
					this.progressIndicatorService.spinner(false);
					this.dialogRef.close();
				},
				(error: any) => {
					this.feedbackService.apiError(error);
					this.progressIndicatorService.spinner(false);
				}
			);
	}
}
